import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getOpenLaborTicketRefs = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.openLaborTicketRefs || [];
  }
);
